// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"280":"4ddf4190","453":"70d4c0ee","516":"06ed3c2a"}[chunkId] + ".chunk.js";
};